<template>
    <a-list
        class="thread-list"
        :loading="loading"
        item-layout="horizontal"
        :data-source="list"
    >
        <a-list-item slot="renderItem" slot-scope="item">
            <a-list-item-meta>
                <span slot="title" class="thread-title">
                    <a :class="{ top: item.top > 0 }"
                        :href="`/bbs/thread/?tid=${item.id}&p=1`"
                    ><Highlight :text="item.title" :keyword="$route.query.q"></Highlight></a>
                </span>
                <div slot="description">
                    <div>{{ item.content }}</div>
                    <div>
                        <user-link :name="item.authorname" :id="item.author"/>
                            发表于{{ formatDate(item.posttime) }} |  {{ item.replycnt }}条回复
                    </div>
                </div>
            </a-list-item-meta>
        </a-list-item>
        <a-pagination :current="Number($route.params.page)" :total="total" 
            :defaultPageSize="20" @change="turnPage" :hideOnSinglePage="true"
        />
    </a-list>
</template>

<script>
import axios from 'axios';
import { createFormData, formatTime } from '../../utils/utils';
import VerdictIcon from '@/components/VerdictIcon.vue';
import UserLink from '@/components/UserLink.vue';
import Highlight from '@/components/Highlight.vue';

export default {
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.load(to.query);
        });
    },
    async beforeRouteUpdate(to, from, next) {
        await this.load(to.query);
        next();
    },
    data: () => ({
        list: [],
        loading: false,
        total: 0,
    }),
    methods: {
        formatDate(timestamp) {
            return formatTime(timestamp, {
                day: "HH:mm:ss",
                year: "MM/DD HH:mm:ss",
                other: "YYYY/MM/DD HH:mm:ss"
            });
        },
        turnPage(page) {
            this.$router.replace({ query: {
                ...this.$route.query,
                p: page
            } });
        },
        async load({ p, q }) {
            if (q === "") {
                this.total = 0;
                this.list = [];
                return;
            }
            this.loading = true;
            const { data } = await axios
                .post("/backend/bbs/search.php", createFormData({
                    page: p, searchstr: q,
                }));
            this.total = data.total;
            this.list = data.list;
            this.loading = false;
        },
    },
    components: {
        VerdictIcon,
        UserLink,
        Highlight,
    },
}
</script>

<style lang="less" scoped>
.ant-list-item-meta {
    text-align: left;
}
.ant-list-item-meta-title {
    font-size: 18px;
    line-height: 24px;
}
.thread-title {
    a {
        color: rgba(0, 0, 0, 0.65);
    }
}
</style>

<style scoped>
.submission-table >>> .my-submission {
    background-color: #E0F2F1;
}
</style>